<template>
  <component :is="tag" :class="['price-formatter', rootClass]">
    <span
      v-if="showCurrency"
      :class="['price-formatter__currency', currencyClass]"
    >
      <img
        v-if="currencyImage"
        :src="currencyImage"
        alt="Currency"
        :class="['price-formatter__image', imageClass]"
      />
      <span v-else :class="['price-formatter__text', textClass]">
        {{ currencyLabel }}
      </span>
    </span>
    <span
      v-if="price !== undefined && price !== null"
      :class="['price-formatter__amount', amountClass]"
    >
      {{ formattedPrice }}
    </span>
  </component>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PriceFormatter",
  props: {
    price: {
      type: [Number, String],
      required: false,
      default: null,
    },
    tag: {
      type: String,
      default: "span",
    },
    rootClass: {
      type: [String, Array, Object],
      default: "",
    },
    textClass: {
      type: [String, Array, Object],
      default: "",
    },
    currencyClass: {
      type: [String, Array, Object],
      default: "",
    },
    imageClass: {
      type: [String, Array, Object],
      default: "",
    },
    amountClass: {
      type: [String, Array, Object],
      default: "",
    },
    fallbackSymbol: {
      type: String,
      default: "",
    },
    showCurrency: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("app", [
      "currencySymbol",
      "internalCurrency",
      "internalCurrencyEnabled",
    ]),
    formattedPrice() {
      const numericPrice = parseFloat(this.price);
      if (Number.isNaN(numericPrice)) {
        return this.price;
      }
      return numericPrice.toFixed(2);
    },
    currencyImage() {
      if (!this.internalCurrencyEnabled || !this.internalCurrency) {
        return "";
      }
      return this.internalCurrency.image || "";
    },
    currencyLabel() {
      if (this.internalCurrencyEnabled && this.internalCurrency) {
        return (
          this.internalCurrency.name ||
          this.internalCurrency.symbol ||
          this.fallbackSymbol
        );
      }
      return this.fallbackSymbol || this.currencySymbol;
    },
  },
};
</script>

<style scoped>
.price-formatter {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  vertical-align: middle;
}

.price-formatter__currency {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
}

.price-formatter__image {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.price-formatter__text,
.price-formatter__amount {
  color: inherit;
}
</style>
